import RespDeclarOwner from '../../../assets/documents/User Manual - Νομικό Πρόσωπο.pdf';

  export const registerDocs = () =>
  [
    {
      label: "Πιστοποιητικό ισχύουσας εκπροσώπησης ΓΕΜΗ",
      fileCode: 'certGemi',
      id: 'certGemi',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Στοιχεία μητρώου επιχείρησης ΑΑΔΕ",
      fileCode: 'registAade',
      id: 'registAade',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Υπεύθυνη δήλωση",
      fileCode: 'respStatement',
      id: 'respStatement',
      multiple: false,
      fileLimit: 10,
      required: true,
      template: {
        required: true,
        docName: 'Υπόδειγμα',
        docPath: RespDeclarOwner
      }
    },
  ].filter(item => item);